import Navbar from "../../components/navbar/navbar";
import ContactMe from "../../components/Contact/ContactMe";
import Footer from "../../containers/Footer/Footer";

function Contact() {
    return (
        <>
            <Navbar />
            <ContactMe />
            <Footer />
        </>
    );
}

export default Contact;
